module.exports = __webpack_public_path__ + "static/media/powered-by-loft.c868909a.svg";